import { useFormContext } from "react-hook-form";
import { Input } from "@/components/ui/input";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";

type LinkedInFieldProps = {
  name: string;
};

const LinkedInField = ({ name }: LinkedInFieldProps) => {
  const { control } = useFormContext();
  return (
    <FormField
      control={control}
      name={name ?? "member.linkedin_url"}
      render={({ field }) => (
        <FormItem>
          <FormLabel htmlFor="linkedinUrl">
            LinkedIn Profile URL (Optional)
          </FormLabel>
          <FormControl>
            <Input
              type="url"
              id="linkedinUrl"
              placeholder="https://linkedin.com/in/yourprofile"
              {...field}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default LinkedInField;
